import React from 'react'
import LazyLoad from 'react-lazyload'
import { Link } from 'react-router-dom'
const Campuscare = () => {
  return (
     <>
      <div className="campuslogo">
         <Link to="https://entab.online/SXSHIR" target="_blank">
         <LazyLoad><img src="https://webapi.entab.info/api/image/SFXH/public/images/Campulogo.png" className="img-fluid float-end campus" alt="St. Francis Xavier School"/> </LazyLoad>
         </Link>
      </div>
      </>
        
  )
}

export default Campuscare
